import { User } from "./user.model"

export class ISPCStore {
  id: number
  name: string
  searchLabel: string = ''
  storenum: string
  latitude: number
  longitude: number
  address: string
  city: string
  state: string
  zip: string
  distance: number
  is_deleted: boolean
  last_updated: string
  
  constructor() {
  }

  static buildOne(obj: any): ISPCStore {
    let target: ISPCStore = Object.assign(new ISPCStore(), obj)
    return target
  }

  static buildMany(objs: any[]): ISPCStore[] {
    const lobjs = []
    for (const i in objs) {
      if (objs.hasOwnProperty(i)) {
        lobjs.push(ISPCStore.buildOne(objs[i]))
      }
    }
    return lobjs
  }
}

export interface ISPCStoresAndUser {
    stores: ISPCStore[]
    user: User   
}

